import { jsx } from "react/jsx-runtime";
import React from "react";
var shopping_trolley_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 13H7.62l-1 2H18v2H6.62c-.7 0-1.33-.36-1.7-.95-.37-.6-.4-1.33-.09-1.95l1.09-2.18L4.45 5H2V3h2.37c.95 0 1.77.66 1.96 1.59l.09.41H20l-2 8zm-1.51-2 .86-4H6.83l.84 4h8.82z" }), /* @__PURE__ */ jsx("path", { d: "M6.5 21c.8284 0 1.5-.6716 1.5-1.5S7.3284 18 6.5 18 5 18.6716 5 19.5 5.6716 21 6.5 21zm10 0c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5z" })];
};
export {
  shopping_trolley_default as default
};
